import React from 'react'
import { Modal } from 'antd'
import { getState } from '../../../redux/store'
import { api3d } from '../../../api/utils'

interface ISkinModalProps {
	visible: boolean
	onClose: () => void
	isSlim: boolean
}

export const SkinModal = ({ visible, onClose, isSlim } : ISkinModalProps): React.ReactElement => {
	const user = getState(s => s.user)

	return (
		<Modal visible={visible} onCancel={onClose} footer={<></>}>
			<iframe
				style={{
					width: 270,
					height: 420,
					border: 'none',
					display: 'flex',
					marginLeft: 'auto',
					marginRight: 'auto',
				}}
				src={`${api3d}/index.html?uuid=${user.uuid}&slim=${isSlim ? 'true' : 'false'}`}
			/>
		</Modal>
	)
}
